"use strict";

jQuery(function ($) {
  $(".js-faq-title").on("click", function (e) {
    e.preventDefault();
    var $this = $(this);
    if (!$this.hasClass("faq__active")) {
      $(".js-faq-content").slideUp(800);
      $(".js-faq-title").removeClass("faq__active");
      $('.js-faq-rotate').removeClass('faq__rotate');
    }
    $this.toggleClass("faq__active");
    $this.next().slideToggle();
    $('.js-faq-rotate', this).toggleClass('faq__rotate');
  });

  $('.js-select').select2({
    placeholder: 'Select an option'
  });
  $('.categories-button').click(function () {
    $('.sidebar.archive').toggleClass('active');
    $(this).toggleClass('active');
  });
  var accordionBtns = document.querySelectorAll("h3.widget-title");
  accordionBtns.forEach(function (accordion) {
    accordion.onclick = function () {
      this.classList.toggle("is-open");
      var content = this.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    };
  });
  $('a[href*="#"]:not([href="#"])').click(function () {
    var target = $(this.hash);
    var headerHeight = $('.site-header').outerHeight();
    $('html,body').stop().animate({
      scrollTop: target.offset().top - headerHeight
    }, 200);
  });
  if (location.hash) {
    var id = $(location.hash);
  }
  $(window).on('load', function () {
    var headerHeight = $('.site-header').outerHeight();
    if (location.hash) {
      $('html,body').animate({
        scrollTop: id.offset().top - headerHeight
      }, 200);
    }
    ;
  });
  $('.menu-button').on('click', function (event) {
    $('.main-wrapper').toggleClass('active');
    $('body').toggleClass('menu-open');
    $(this).toggleClass('active');
    $('header').addClass('mob-menu');
  });
  $('li.menu-item-has-children').on('click', function (event) {
    var windowSize = $(window).width();
    if (windowSize < 1200) {
      event.stopPropagation();
      var label = $(this);
      var list = label.find('.sub-menu').eq(0);
      if (label.hasClass('is-open')) {
        list.slideUp('fast');
        label.removeClass('is-open');
      } else {
        list.slideDown('fast');
        label.addClass('is-open');
      }
    }
  });
  $('.locations > .sub-menu > li').hover(function () {
    $('.locations > .sub-menu > li').not($(this)).removeClass('active');
    $(this).addClass('active');
  });
  $('.locations > .sub-menu > li > a').on('click', function (event) {
    $('.locations > .sub-menu > li').removeClass('active');
  });
  $(".menu-header").hover(function () {}, function () {
    $('.locations > .sub-menu > li').removeClass('active');
  });
  $('.js_filter_select').select2({
    minimumResultsForSearch: -1,
    closeOnSelect: false,
    placeholder: function placeholder() {
      $(this).data('placeholder');
    }
  });
  $('.js_filter_select').on('select2:selecting', function (e) {
    $(this).next().find('.select2-search').hide();
  });
  $('.js_filter_select').on('select2:unselect', function (e) {
    if ($(this).val() == '') {
      $(this).next().find('.select2-search').show();
    }
  });
  $('.filter_checkbox_title_holder').on('click', function () {
    $(this).toggleClass('active').next('.filter_checkbox_block').slideToggle();
  });
  $('.js_show_more').on('click', function () {
    if ($(window).width() < 1200) {
      $(this).toggleClass('active');
      $('.filter_block_holder_mobile').slideToggle();
    }
  });
  $('.js_tabs_link').on('click', function () {
    $('.js_tabs_link').removeClass('active');
    $(this).addClass('active');
  });
  if ($('div').hasClass('reviews_slider')) {
    var reviews_slider = new Carousel(document.querySelector(".reviews_slider"), {
      slidesPerPage: '1',
      center: false,
      Dots: false,
      fill: false,
      infinite: false,
      Navigation: {
        prevTpl: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' + '<path d="M10.6666 2.66669L5.33329 8.00002L10.6666 13.3334" stroke="#3F3C49" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' + '</svg>',
        nextTpl: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' + '<path d="M5.33337 2.66669L10.6667 8.00002L5.33337 13.3334" stroke="#01254D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' + '</svg>'
      },
      classNames: {
        viewport: "reviews_viewport",
        track: "reviews_track",
        slide: "reviews_slide",
        slideSelected: "is-selected"
      },
      on: {
        ready: function ready(carousel) {
          $('.carousel__dot').removeAttr('role');
        }
      }
    });
  }
  $('.js_title').on('click', function () {
    if ($(window).width() < 1200) {
      $(this).toggleClass('active').next('.js_content').slideToggle();
    }
  });
});